export default "__VITE_ASSET__C1pxMuS7__"